import React from 'react';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import SlideBanner from '@components/common/SlideBanner/SlideBanner';
import NewsNav from '@components/NewsTNH/NewsNav';
import NewsList from '@components/NewsTNH/NewsList';
import {NextSeo} from 'next-seo';
import NewsService from '@services/news.service';
import {generateNewsListSEO} from '@helper/seo/generators/news';

export default function News(props) {
    const {locale} = useRouter();
    const {seoPage} = props;
    
    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
            <SlideBanner titleBanner={getLocaleContent(locale, 'page.news-page.page-title')} />
            <NewsNav />
            <NewsList />
        </div>
        </>
    );
}

News.getInitialProps = async (context) => {
    try {
        const ctx = context || {};
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || process.env.WEB_URL || 'https://tnh.com.vn';
        
        // Fetch data thực tế từ API
        let newsList = [];
        let totalCount = 0;
        try {
            const newsService = new NewsService(ctx);
            
            // Lấy danh sách tin tức (lấy khoảng 15-20 items đầu để tạo SEO, không cần hết vì có load more)
            const newsResponse = await newsService.getNewsList({
                locale: ctx.locale || 'vn',
                pageSize: 20,
                pageIndex: 1,
                is_news: 1 // Chỉ lấy tin tức, không lấy ưu đãi
            });
            
            // Xử lý response structure
            if (newsResponse) {
                // Lấy total count
                if (newsResponse.total !== undefined) {
                    totalCount = parseInt(newsResponse.total) || 0;
                } else if (newsResponse.totalCount !== undefined) {
                    totalCount = parseInt(newsResponse.totalCount) || 0;
                }
                
                // Lấy danh sách news
                if (Array.isArray(newsResponse)) {
                    newsList = newsResponse;
                } else if (newsResponse.items && Array.isArray(newsResponse.items)) {
                    newsList = newsResponse.items;
                } else if (newsResponse.data && Array.isArray(newsResponse.data)) {
                    newsList = newsResponse.data;
                } else if (newsResponse.newsList && Array.isArray(newsResponse.newsList)) {
                    newsList = newsResponse.newsList;
                }
            }
        } catch (err) {
            console.error('Failed to fetch news data for SEO:', err);
        }
        
        // Tạo SEO từ data thực tế
        const seoPage = generateNewsListSEO(newsList, totalCount, webUrl);
        
        return {seoPage};
    } catch (error) {
        console.error('Failed to fetch SEO for news page:', error);
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || process.env.WEB_URL || 'https://tnh.com.vn';
        // Fallback SEO
        const seoPage = generateNewsListSEO([], 0, webUrl);
        return {seoPage};
    }
};
